<template>
  <div class="employDetail">
    <el-form
      :model="formData"
      size="small"
      label-width="130px"
      class="form-horizontal detail-form detail-text-form"
      style="margin-bottom: 10px"
    >
      <el-form-item prop="typeId" class="is-required" label="姓名：">
        {{ formData.name }}
      </el-form-item>
      <el-form-item prop="typeId" class="is-required" label="证件种类：">
        {{ formData.certType }}
      </el-form-item>
      <el-form-item prop="typeId" class="is-required" label="证件号码：">
        {{ formData.certCode }}
      </el-form-item>
      <el-form-item prop="typeId" label="联系电话：">
        {{ formData.phone }}
      </el-form-item>
      <el-form-item prop="typeId" label="人员类型：">
        {{ formData.staffTypeName }}
      </el-form-item>
      <el-form-item prop="typeId" label="登记时间：">
        {{ formData.createTime }}
      </el-form-item>
      <el-form-item prop="typeId" label="更新时间：">
        {{ formData.updateTime }}
      </el-form-item>
      <!-- <el-form-item  prop="typeId" label="工作单位："  >
        {{formData.dwmc}}
      </el-form-item>
      <el-form-item  prop="typeId" label="社会信用代码："  >
        {{formData.shxydm}}
      </el-form-item>
      <el-form-item  prop="typeId" label="工作地："  class="rowItem">
        {{formData.wyfdzSsxqdm}}
      </el-form-item> -->

      <r-table
        class="detail-table"
        :ref="tableVarity"
        :columns="tableColumn"
        :dataSource="tableData"
        :options="options"
        @current-change="handlePageChange"
      ></r-table>
    </el-form>
  </div>
</template>

<script>
import RTable from '@/components/common/RTable'
import tableMix from '@/components/common/tableListMixin.js'
export default {
  name: 'employeeDetail',
  mixins: [tableMix],
  components: { RTable },
  data() {
    let detailKeys = [
      'xm',
      'xmShow',
      'cyzjdm',
      'zjhm',
      'lxdh',
      'lxdhShow',
      'zjhmShow',
      'dwmc',
      'shxydm',
      'rylx',
      'dwbgdzQbm',
      'rzsj',
      'lzsj',
      'cyzjdm_translate',
      'rylx_translate',
    ]
    let formData = {}
    detailKeys.map((key) => {
      formData[key] = ''
    })
    return {
      activeNames: ['1', '2', '3', '4', '5', '6'],
      item: { value: 'aaa' },
      formData: formData,

      tableVarity: 'baseinfo-employee-detail-table',
      options: {
        loading: false, // 加载中状态
        serialNum: true, // 显示序号
        initTable: true, // 是否一挂载就加载数据
        maxHeight: '400px', //高度
        multiSelect: false, // 多选
        mutiSelect: false,
        selection: false,
      },
    }
  },
  props: {
    selOptions: {
      type: Object,
      default: { cyzjdm: [], rylx: [] },
    },
    detailModal: { type: Boolean, default: false },
    detailData: { type: Object, default: {} },
  },
  watch: {
    detailModal: {
      immediate: true,
      handler: function (to) {
        if (to === false) {
          return false
        }
        this.getQuery()

        for (let key in this.detailData) {
          this.formData[key] = this.detailData[key] ? this.detailData[key] : '--'
        }

        this.selOptions.cyzjdm.map((item) => {
          if (item.name == this.detailData.cyzjdm) {
            this.formData['cyzjdm_translate'] = item.value
          }
        })
        this.selOptions.rylx.map((item) => {
          if (item.name == this.detailData.rylx) {
            this.formData['rylx_translate'] = item.value
          }
        })
      },
    },
  },
  created() {
    this.initTableColumns()
  },
  methods: {
    getQuery() {
      this.options.loading = true
      this.fetchData({
        url: 'CLEAN.CLEANER.GET_DETAIL',
        method: 'get',
        params: {
          id: this.detailData.id,
        }
      }).then(res => {
        this.tableData = res.experiences;
      }).finally(() => {
        this.options.loading = false
      })
    },
    // 初始化自定义表头
    initTableColumns() {
      let columns = [
        { prop: 'company', label: '工作单位', visible: true, minWidth: 200, isInput: true },
        { prop: 'socialCreditCode', label: '社会信用代码', visible: true, minWidth: 180, isInput: true  },
        { prop: 'hireDate', label: '入职日期', visible: true, minWidth: 160, isInput: false },
      ]

      this.tableColumn = columns
    },
  },
}
</script>

<style lang="less" scoped>
.detail-form {
  display: flex;
  flex-wrap: wrap;
}

.employeeTable /deep/ .cell.col-is-required:before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
}
.detail-table {
  width: 100%;
}
</style>
